import {MAX_VALUE_INPUT_LIMITER} from "@pg-design/inputs-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRegion} from "../../region/fetch_region_path";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {SearchTab} from "../types/SearchTab";
import {getSearchUrlWithFilters} from "./get_search_url_with_filters";
import type {IRecentFiltersDisplayLinkConfig} from "./recent_filters_display_utils";
import {IRecentFilter} from "./recent_filters_storage";
import {RESTORED_FILTERS_ENABLED_VALUE} from "./restored_filters";

export const recentFiltersLinkConfig: IRecentFiltersDisplayLinkConfig = {
    singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
    abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
    multiRegionLink: rpAppLink.offer.multiList
};

export const buildSurveySearchFormValues = (surveyData: ISurveyData, surveyRegions: IRegion[]): ISearchFormValues => ({
    rooms: {
        lower: surveyData.rooms?.lower ?? "",
        upper: surveyData.rooms?.upper ?? ""
    },
    price: {
        lower: surveyData.price?.lower != null && surveyData.price.lower < MAX_VALUE_INPUT_LIMITER ? surveyData.price.lower.toString() : "",
        upper: surveyData.price?.upper != null && surveyData.price.upper < MAX_VALUE_INPUT_LIMITER ? surveyData.price.upper.toString() : ""
    },
    search: {
        label: "",
        tabType: SearchTab.Regions,
        regions: surveyRegions
    } as ISearchInputValue,
    type: [],
    area: null,
    floor_choices: [],
    construction_end_date: null,
    distance: null,
    house_type: null,
    house_additional_areas: null,
    house_storeys: null,
    instalment: null
});

export const buildRecentSearchFormValues = (recentFilter: IRecentFilter): ISearchFormValues => ({
    search: recentFilter.search,
    type: recentFilter.filters.type ?? [],
    rooms: recentFilter.filters.rooms,
    price: recentFilter.filters.price,
    area: recentFilter.filters.area || null,
    instalment: recentFilter.filters.instalment || null,
    floor_choices: [],
    construction_end_date: recentFilter.filters.construction_end_date ?? null,
    distance: null,
    house_type: null,
    house_additional_areas: null,
    house_storeys: null
});

export const buildSearchUrl = (searchFormValues: ISearchFormValues): string =>
    getSearchUrlWithFilters({
        ...recentFiltersLinkConfig,
        latestQuery: {},
        searchFormValues,
        additionalParams: {
            restored_filters: RESTORED_FILTERS_ENABLED_VALUE
        }
    }).url;
import {MAX_VALUE_INPUT_LIMITER} from "@pg-design/inputs-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRegion} from "../../region/fetch_region_path";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {SearchTab} from "../types/SearchTab";
import {getSearchUrlWithFilters} from "./get_search_url_with_filters";
import type {IRecentFiltersDisplayLinkConfig} from "./recent_filters_display_utils";
import {IRecentFilter} from "./recent_filters_storage";
import {RESTORED_FILTERS_ENABLED_VALUE} from "./restored_filters";

export const recentFiltersLinkConfig: IRecentFiltersDisplayLinkConfig = {
    singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
    abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
    multiRegionLink: rpAppLink.offer.multiList
};

export const buildSurveySearchFormValues = (surveyData: ISurveyData, surveyRegions: IRegion[]): ISearchFormValues => ({
    rooms: {
        lower: surveyData.rooms?.lower ?? "",
        upper: surveyData.rooms?.upper ?? ""
    },
    price: {
        lower: surveyData.price?.lower != null && surveyData.price.lower < MAX_VALUE_INPUT_LIMITER ? surveyData.price.lower.toString() : "",
        upper: surveyData.price?.upper != null && surveyData.price.upper < MAX_VALUE_INPUT_LIMITER ? surveyData.price.upper.toString() : ""
    },
    search: {
        label: "",
        tabType: SearchTab.Regions,
        regions: surveyRegions
    } as ISearchInputValue,
    type: [],
    area: null,
    floor_choices: [],
    construction_end_date: null,
    distance: null,
    house_type: null,
    house_additional_areas: null,
    house_storeys: null,
    instalment: null
});

export const buildRecentSearchFormValues = (recentFilter: IRecentFilter): ISearchFormValues => ({
    search: recentFilter.search,
    type: recentFilter.filters.type ?? [],
    rooms: recentFilter.filters.rooms,
    price: recentFilter.filters.price,
    area: recentFilter.filters.area || null,
    instalment: recentFilter.filters.instalment || null,
    floor_choices: [],
    construction_end_date: recentFilter.filters.construction_end_date ?? null,
    distance: null,
    house_type: null,
    house_additional_areas: null,
    house_storeys: null
});

export const buildSearchUrl = (searchFormValues: ISearchFormValues): string =>
    getSearchUrlWithFilters({
        ...recentFiltersLinkConfig,
        latestQuery: {},
        searchFormValues,
        additionalParams: {
            restored_filters: RESTORED_FILTERS_ENABLED_VALUE
        }
    }).url;
